// imports
import ActivityHeatMapDataModel from '$models/volunteers/ActivityHeatMapDataModel';
import Config from '$root/Config';
import xmlToCompact from '$utils/xmlToCompact';
import MinskyCollection from '../MinskyCollection';

const EMPTY_HEATMAP = {
	data: [
		{
			count: 0,
			data: null,
		},
	],
};

function compactGpx(data) {
	if (data == null || data === '') {
		return {};
	}

	if (typeof data !== 'string') {
		if (typeof XMLDocument !== 'undefined' && data instanceof XMLDocument && data.documentElement) {
			return xmlToCompact(new XMLSerializer().serializeToString(data));
		}
		return {};
	}

	try {
		return xmlToCompact(data);
	} catch (error) {
		return {};
	}
}

function setHeatmapLoadingMessage(message) {
	if (window.vueStore?.commit) {
		window.vueStore.commit('activitiesDM/setLoadingMessage', message);
		return;
	}

	if (window.vueStore?.state?.activitiesDM) {
		window.vueStore.state.activitiesDM.loadingMessage = message;
	}
}

// class definition
export default class ActivityHeatMapCollection extends MinskyCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || ActivityHeatMapDataModel;
		args.config = {
			url: Config.getUrl('activityHeatMapData'),
			responseType: 'text'
		};
		args.filterConversions = [
			{
				key: 'created',
				action: 'timestampArrayToSeconds'
			}
		];
		// call super constructor
		super(args);
	}

    fetch(preventClear) {
		this.setConfig('url', `${Config.getUrl('activityHeatMapData')}`);

		return super.fetch(preventClear);
	}

    parse(data) {
		const compact = compactGpx(data);
		let count = 0
		if (compact.gpx && compact.gpx.trk && compact.gpx.trk.length) {
			count = compact.gpx.trk.length
		} else if (compact.gpx && compact.gpx.trk) {
			count = 1
		}

		if (!count) {
			return super.parse(EMPTY_HEATMAP);
		}
		
		data = {
			data: [
				{
					count: count,
					data: compact.gpx.trk,
				}
			],
		}
        return super.parse(data);
    }

	response(xhr) {
		if (xhr.status === 202) {
			setHeatmapLoadingMessage('De heatmap wordt aangemaakt. Dit kan even duren.')
			super.response(xhr);
		} else {
			setHeatmapLoadingMessage('')
			super.response(xhr);
		}
	}
}
